export function toCSSLength(val) {
  return typeof val === 'number' ? "".concat(val, "px") : val;
}